// Utility functions for SLA configuration and resolution
export type SlaType = string;
export type CloudName = string;

/**
 * Gets the SLA value for a given type and cloud name
 * @param slaType The type of SLA (SRM or CTS)
 * @param cloudName Optional cloud name for cloud-specific SLA
 * @returns The SLA string value
 */
export const getSLA = (slaType: SlaType, cloudName?: string): string => {
    if (!cloudName) {
        const envVarName = `REACT_APP_${slaType}_SLA`;
        return process.env[envVarName] || 'undefined';
    }

    const cloudSpecificEnvVar = `REACT_APP_${slaType}_${cloudName.toUpperCase()}_SLA`;
    const cloudSpecificSLA = process.env[cloudSpecificEnvVar];
    if (cloudSpecificSLA) {
        return cloudSpecificSLA;
    }

    // Fallback to default SLA
    const defaultEnvVar = `REACT_APP_${slaType}_SLA`;
    return process.env[defaultEnvVar] || 'undefined';
};

/**
 * Gets all available cloud names that have SLA configuration
 * @returns Array of cloud names that have specific SLA configurations
 */
export const getAvailableCloudSlaConfigurations = (): string[] => {
    const clouds: string[] = [];
    const envKeys = Object.keys(process.env);

    envKeys.forEach((key) => {
        const match = key.match(/^REACT_APP_(SRM|CTS)_(.+)_SLA$/);
        if (match && match[2]) {
            const cloudName = match[2];
            if (!clouds.includes(cloudName)) {
                clouds.push(cloudName);
            }
        }
    });

    return clouds.sort();
};
